import { HttpClient } from '@angular/common/http';
import { all } from 'deepmerge';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

/*
 * Public API Surface of osc-reference-app-common
 */
export * from './osc-reference-app-common.module';

// components
export * from './components/about-modal/about-modal.component';

// models
export * from './interfaces/card-menu-item';
export * from './interfaces/about-modal-config';
export * from './interfaces/page-list-item';


// services
export * from './services/dialog.service';

export class CustomTranslateHttpLoader {
  public constructor(private http: HttpClient, private resources: { prefix; suffix }[]) { }
  public static CustomHttpLoaderFactory(http: HttpClient, resource: { prefix; suffix }[]): CustomTranslateHttpLoader {
    return new CustomTranslateHttpLoader(http, resource);
  }

  public getTranslation(lang) {
    const requests = this.resources.map(resource => {
      const path = resource.prefix + lang + resource.suffix;
      return this.http.get(path).pipe(
        catchError(res => {
          console.error('Something went wrong for the following translation file:', path);
          console.error(res.message);
          if (lang === 'en') {
            return of({});
          } else {
            const defaultPath = resource.prefix + 'en' + resource.suffix;
            return this.http.get(defaultPath).pipe(catchError(result => of({})));
          }
        })
      );
    });
    return forkJoin(requests).pipe(map(response => all(response)));
  }
}
